/* eslint-disable max-len */
export default {
  buyOneGetOne: {
    plpMessage: 'Free Gift With Purchase',
    analyticsMessage: 'free-gift'
  },
  buyOneGetPercentageOff: {
    plpMessage: 'Buy One, Get One {{rewardAmount}} Off',
    analyticsMessage: 'bogo{{analyticsRewardAmount}}pctoff'
  },
  buyOneGetDollarOff: {
    plpMessage: 'Buy One, Get One {{rewardAmount}} Off',
    analyticsMessage: 'bogod{{analyticsRewardAmount}}off'
  },
  buyThePairAndSave: {
    plpMessage: 'Buy the Pair and Save',
    analyticsMessage: 'pair-save'
  },
  buyOneGetY: {
    plpMessage: 'Buy {{src1MinPurchaseQuantityWord}}, Get {{tgt1MinPurchaseQuantity}} Free',
    analyticsMessage: 'b{{src1MinPurchaseQuantity}}g{{tgt1MinPurchaseQuantity}}free'
  },
  buyXGetOne: {
    plpMessage: 'Buy {{src1MinPurchaseQuantity}}, Get {{tgt1MinPurchaseQuantityWord}} Free',
    analyticsMessage: 'b{{src1MinPurchaseQuantity}}g{{tgt1MinPurchaseQuantity}}free'
  },
  buyOneGetYPercentageOff: {
    plpMessage: 'Buy {{src1MinPurchaseQuantityWord}}, Get {{tgt1MinPurchaseQuantity}} {{rewardAmount}} Off',
    analyticsMessage: 'b{{src1MinPurchaseQuantity}}g{{tgt1MinPurchaseQuantity}}{{analyticsRewardAmount}}percentoff'
  },
  buyXGetOnePercentageOff: {
    plpMessage: 'Buy {{src1MinPurchaseQuantity}}, Get {{tgt1MinPurchaseQuantityWord}} {{rewardAmount}} Off',
    analyticsMessage: 'b{{src1MinPurchaseQuantity}}g{{tgt1MinPurchaseQuantity}}-{{analyticsRewardAmount}}pctoff'
  },
  buyOneGetYDollarOff: {
    plpMessage: 'Buy {{src1MinPurchaseQuantityWord}}, Get {{tgt1MinPurchaseQuantity}} {{rewardAmount}} Off',
    analyticsMessage: 'b{{src1MinPurchaseQuantity}}g{{tgt1MinPurchaseQuantity}}dollar{{analyticsRewardAmount}}off'
  },
  buyXGetOneDollarOff: {
    plpMessage: 'Buy {{src1MinPurchaseQuantity}}, Get {{tgt1MinPurchaseQuantityWord}} {{rewardAmount}} Off',
    analyticsMessage: 'b{{src1MinPurchaseQuantity}}g{{tgt1MinPurchaseQuantity}}d{{analyticsRewardAmount}}off'
  },
  buyOneGetYBackwards: {
    plpMessage: 'Free With Eligible Purchase',
    analyticsMessage: 'revbuyOneGetY'
  },
  buyOneGetOneBackwards: {
    plpMessage: 'Free With Eligible Purchase',
    analyticsMessage: 'revbogofree'
  },
  buyOneGetPercentageOffBackwards: {
    plpMessage: '{{rewardAmount}} Off With Eligible Purchase',
    analyticsMessage: 'revbogo{{analyticsRewardAmount}}pctoff'
  },
  buyOneGetDollarOffBackwards: {
    plpMessage: '{{rewardAmount}} Off With Eligible Purchase',
    analyticsMessage: 'revbogod{{analyticsRewardAmount}}off'
  },
  buyMinAmountGetOne: {
    plpMessage: 'Spend {{qualifyingAmount}}, Choose Free Items',
    analyticsMessage: 'sd{{analyticsQualifyingAmount}}choosefree'
  },
  buyMinAmountGetDollarOff: {
    plpMessage: 'Get {{rewardAmount}} Off Additional Items',
    analyticsMessage: 'b{{analyticsQualifyingAmount}}gd{{analyticsRewardAmount}}pctoff'
  },
  buyMinAmountGetPercentageOff: {
    plpMessage: 'Get {{rewardAmount}} Off Additional Items',
    analyticsMessage: 'b{{analyticsQualifyingAmount}}g{{analyticsRewardAmount}}pctoff'
  },
  MSB1: {
    plpMessage: 'Buy {{qualifyingAmount}} or More, Get {{rewardAmount}} Off',
    analyticsMessage: 'b{{analyticsQualifyingAmount}}plusd{{analyticsRewardAmount}}off'
  },
  MSB2: {
    plpMessage: 'Buy {{qualifyingAmount}} or More, Get {{rewardAmount}} Off Order',
    analyticsMessage: 'b{{analyticsQualifyingAmount}}plusd{{analyticsRewardAmount}}offorder'
  },
  MSB3: {
    plpMessage: 'Buy {{qualifyingAmount}} or More, Get {{rewardAmount}} Off Each',
    analyticsMessage: 'b{{analyticsQualifyingAmount}}plusd{{analyticsRewardAmount}}offeach'
  },
  MSB4: {
    plpMessage: 'Spend {{qualifyingAmount}}, Get {{rewardAmount}} Off',
    analyticsMessage: 'sp{{analyticsQualifyingAmount}}g{{analyticsRewardAmount}}off'
  },
  MSB5: {
    plpMessage: 'Spend {{qualifyingAmount}}, Get {{rewardAmount}} Off Order',
    analyticsMessage: 'sp{{analyticsQualifyingAmount}}g{{analyticsRewardAmount}}offorder'
  },
  MSB6: {
    plpMessage: 'Spend {{qualifyingAmount}}, Get {{rewardAmount}} Off Each',
    analyticsMessage: 'sp{{analyticsQualifyingAmount}}g{{analyticsRewardAmount}}offeach'
  },
  MSB7: {
    plpMessage: 'Buy {{qualifyingAmount}} or More, Get Fixed Price',
    analyticsMessage: 'b{{analyticsQualifyingAmount}}gfixed'
  },
  BMSM1Categorized: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM2Categorized: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM3Categorized: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM4Categorized: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM5Categorized: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM6Categorized: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM7Categorized: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM1: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM2: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM3: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM4: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM5: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM6: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BMSM7: {
    plpMessage: 'Buy More, Save More',
    analyticsMessage: 'bmsm'
  },
  BUNDLE: {
    plpMessage: 'Bundle Savings',
    analyticsMessage: 'bundle'
  }
};
